document.addEventListener('alpine:init', () => {
  Alpine.data(
    'TheList',
    ({
      delaySeconds,
      dismissDays,
      successDays,
      previewMode,
      enabled,
      errorText,
      serverErrorText,
    }) => ({
      delaySeconds,
      dismissDays,
      successDays,
      previewMode,
      enabled,
      errorText,
      serverErrorText,
      stage: 'prompt',
      submitting: false,
      errorMessage: '',
      sectionId: null,
      storageKey: null,
      sessionKey: null,
      _triggered: false,
      _cleanupTrigger: null,
      init() {
        this.sectionId = this.$root.id;
        this.storageKey = `the-list-${this.sectionId}`;
        this.sessionKey = `the-list-session-${this.sectionId}`;

        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge') return;

        initTeleport(this.$root);

        Alpine.store('modals').register('theList', 'popup');

        document.body.addEventListener('the-list-is-closed', () => {
          this.onClosed();
        });

        if (!Shopify.designMode) {
          if (this.previewMode) {
            this.open();
            return;
          }

          if (getExpiringStorageItem(this.storageKey) === 'subscribed') return;
          if (sessionStorage.getItem(this.sessionKey)) return;

          const trigger = () => {
            if (this._triggered) return;
            this._triggered = true;
            sessionStorage.setItem(this.sessionKey, '1');
            this.open();
          };

          const timer = setTimeout(
            trigger,
            Math.max(this.delaySeconds, 0) * 1000
          );

          const onScroll = () => {
            const scrolled = window.scrollY;
            const scrollable =
              document.documentElement.scrollHeight - window.innerHeight;

            if (
              scrolled > 400 ||
              (scrollable > 0 && scrolled / scrollable > 0.25)
            ) {
              trigger();
            }
          };

          window.addEventListener('scroll', onScroll, { passive: true });

          this._cleanupTrigger = () => {
            clearTimeout(timer);
            window.removeEventListener('scroll', onScroll);
          };
        } else {
          if (window.theme.designMode.selected === this.sectionId) {
            if (this.enabled === true) {
              this.open();
            } else {
              // It might be open from a previous instantiation
              Alpine.store('modals').close('theList');
            }
          }

          document.addEventListener(
            'shopify:section:select',
            this.onSectionSelect.bind(this)
          );

          document.addEventListener(
            'shopify:section:deselect',
            this.onSectionDeselect.bind(this)
          );
        }
      },
      open() {
        this.stage = 'prompt';
        this.errorMessage = '';
        this.$store.modals.open('theList');
        setTimeout(() => this.$focus.first(), 50);
      },
      close() {
        this.$store.modals.close('theList');
      },
      onClosed() {
        if (this._cleanupTrigger) this._cleanupTrigger();

        if (this.stage !== 'success' && !Shopify.designMode) {
          setExpiringStorageItem(
            this.storageKey,
            'dismissed',
            daysInMs(this.dismissDays)
          );
        }
      },
      answerYes() {
        if (getExpiringStorageItem(this.storageKey) === 'subscribed') {
          this.stage = 'success';
          setTimeout(() => this.close(), 1400);
        } else {
          this.stage = 'email';
          setTimeout(
            () => this.$refs.emailInput && this.$refs.emailInput.focus(),
            50
          );
        }
      },
      answerNo() {
        this.stage = 'email';
        setTimeout(
          () => this.$refs.emailInput && this.$refs.emailInput.focus(),
          50
        );
      },
      async submit(event) {
        if (this.submitting) return;

        const form = event.target;

        if (!form.checkValidity()) {
          this.errorMessage = this.errorText;
          setTimeout(
            () => this.$refs.emailInput && this.$refs.emailInput.focus(),
            50
          );
          return;
        }

        this.submitting = true;
        this.errorMessage = '';

        try {
          const res = await fetch(form.action, {
            method: 'POST',
            credentials: 'same-origin',
            body: new URLSearchParams(new FormData(form)),
            redirect: 'follow',
          });

          if (!res.ok) throw new Error(`Shopify ${res.status}`);

          const html = await res.text();
          const doc = parseDOMFromString(html);

          if (doc.querySelector('[data-the-list-success]')) {
            this.stage = 'success';

            if (!Shopify.designMode) {
              setExpiringStorageItem(
                this.storageKey,
                'subscribed',
                daysInMs(this.successDays)
              );
            }

            setTimeout(() => this.close(), 1600);
          } else if (doc.querySelector('[data-the-list-error]')) {
            this.errorMessage = this.errorText;
            setTimeout(
              () => this.$refs.emailInput && this.$refs.emailInput.focus(),
              50
            );
          } else {
            this.errorMessage = this.serverErrorText;
          }
        } catch (e) {
          this.errorMessage = this.serverErrorText;
        } finally {
          this.submitting = false;
        }
      },
      onSectionSelect(e) {
        if (!e.target.contains(this.$root)) return;

        if (!this.enabled) return;

        this.open();
      },
      onSectionDeselect(e) {
        if (!e.target.contains(this.$root)) return;

        this.$store.modals.close('theList');
      },
      destroy() {
        if (this._cleanupTrigger) this._cleanupTrigger();

        document.removeEventListener(
          'shopify:section:select',
          this.onSectionSelect
        );

        document.removeEventListener(
          'shopify:section:deselect',
          this.onSectionDeselect
        );
      },
    })
  );
});
